import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerTwo from "../components/DashBoardLayerTwo";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import {onBackgroundMessage} from 'firebase/messaging/sw'
import firebase from 'firebase/app';
import 'firebase/messaging';
import { messaging } from "../helper/firebase";
import ChatComponent from "./ChatComponent";

const HomePageTwo = () => {

const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, { vapidKey: "BAFPuUj-3e6_p8FFVmZkLwsc_08cMXTSsrr_k2CxW2zu3aEGVKpYHWo_RBx6Q420UZbzl-IuTrmot8RtRuUIDGs" });
      
      // postTokenToApi(token);
    } else if (permission === 'denied') {
      console.log('Notification permission denied');
      // Handle denied permission gracefully
    } else {
      console.log('Notification permission dismissed');
    }
  } catch (error) {
    console.error('Error requesting permission:', error);
  }
};
  React.useEffect(() => {
    requestNotificationPermission()
    const user = localStorage.getItem("user");
    if (user === null) {
      const location  = localStorage.getItem('locationID');
      window.location.href=`/sign-in?id=${location}`
    }
  }, [1]);
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
          <h6 className="fw-semibold mb-0">{"Dashboard"}</h6>
        </div>
        {/* DashBoardLayerTwo */}
        <DashBoardLayerTwo />
        <ChatComponent/>
      </MasterLayout>
    </>
  );
};

export default HomePageTwo;
